module.exports = __webpack_public_path__ + "img/available_device.8a0af997.png";